<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 부서 -->
          <c-dept 
            type="search" 
            label="LBLDEPT" 
            name="seniorDeptCd" 
            v-model="searchParam.seniorDeptCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 선임자 -->
          <c-field 
            type="user" 
            label="LBL0010211" 
            name="seniorUserId" 
            v-model="searchParam.seniorUserId" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 선임기간 -->
          <c-datepicker
            :range="true"
            name="period"
            label="LBL0010212"
            v-model="period"
          ></c-datepicker>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="seniorDismissal"
      title="선해임 이력관리 목록"
      tableId="seniorDismissal"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :merge="grid.merge"
      :data="grid.data"
      rowKey="seniorUserId"
      :columnSetting="false"
      :expandAll="true"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'senior-dismissal-status',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'seniorClassName',
            field: 'seniorClassName',
            label: '구분',
            align: 'center',
            style: 'width:60px',
            sortable: true,
          },
          {
            name: 'seniorName',
            field: 'seniorName',
            label: '법정선임대상',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'seniorDeadline',
            field: 'seniorDeadline',
            label: '선임기한',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'plantName',
            field: 'plantName',
            label: '선임사업장',
            align: 'center',
            style: 'width:60px',
            sortable: true,
          },
          {
            name: 'seniorUserName',
            field: 'seniorUserName',
            label: '현재 선임자',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'changeSeniorUserName',
            field: 'changeSeniorUserName',
            label: '변경전 선임자',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'qualifiyRequire',
            field: 'qualifiyRequire',
            label: '선임자격',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: "regDtStr",
            field: 'regDtStr',
            label: '개정일시',
            align: 'center',
            style: 'width:60px',
            sortable: true,
          },
          {
            name: "seniorRevTypeName",
            field: 'seniorRevTypeName',
            label: '개정사유',
            align: 'left',
            style: 'width:140px',
            sortable: true,
          },
        ],
        data: [],
        merge: [
          { index: 0, colName: 'seniorClassName' },
          { index: 1, colName: 'seniorName' },
        ]
      },
      data: {
        seniorStatusId: '',
      },
      searchParam: {
        plantCd: '',
        seniorDeptCd: '',
        seniorUserId: '',
        startYmd: '',
        endYmd: '',
      },
      period: [],
      editable: true,
      listUrl: '',
      saveUrl: '',
      isSave: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.mdm.senior.status.history.url;
      this.saveUrl = transactionConfig.mdm.senior.status.remark.url;
      this.printUrl = selectConfig.sop.swp.workPermit.print.url
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
  }
};
</script>
